<!-- Axylog Detail Popup -->
<div class="popup-overlay" [class.show]="visible" (click)="onBackdropClick($event)">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h4 class="popup-title">
        <i class="fas fa-cloud-upload-alt me-2"></i>
        {{ 'AXYLOG_POPUP.TITLE' | translate }}
      </h4>
      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <!-- Selected Waybills Section -->
      <div class="detail-section">
        <h5 class="section-title">
          <i class="fas fa-list me-2"></i>
          {{ 'AXYLOG_POPUP.SELECTED_WAYBILLS' | translate }}
          <span class="badge bg-primary ms-2">{{ localWaybillCodes.length }}</span>
        </h5>
        
        <div class="waybills-container" *ngIf="localWaybillCodes.length > 0">
          <div class="waybill-item" *ngFor="let waybillCode of localWaybillCodes; trackBy: trackByWaybillCode">
            <div class="waybill-info">
              <i class="fas fa-file-invoice me-2"></i>
              <span class="waybill-code">{{ waybillCode }}</span>
            </div>
            <button 
              type="button" 
              class="btn-remove"
              (click)="removeWaybill(waybillCode); $event.stopPropagation();"
              [title]="'AXYLOG_POPUP.REMOVE' | translate">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <div class="empty-state" *ngIf="localWaybillCodes.length === 0">
          <i class="fas fa-exclamation-triangle text-warning"></i>
          <p class="mb-0">{{ 'AXYLOG_POPUP.NO_WAYBILLS_SELECTED' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="popup-footer">
      <button type="button" class="btn btn-secondary me-2" (click)="close()">
        <i class="fas fa-times me-2"></i>
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="onConfirm()"
        [disabled]="localWaybillCodes.length === 0 || isSending">
        <i [class]="isSending ? 'fas fa-spinner fa-spin me-2' : 'fas fa-cloud-upload-alt me-2'"></i>
        {{ (isSending ? 'AXYLOG_POPUP.SENDING' : 'AXYLOG_POPUP.SEND_TO_AXYLOG') | translate }}
      </button>
    </div>
  </div>
</div>
